"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./LanguageSelector.scss");
var _iconGlobe = _interopRequireDefault(require("../../images/icon-globe.svg"));
var _checkBlue = _interopRequireDefault(require("../../images/check-blue.svg"));
var _lodash = require("lodash");
var _closeIcon = _interopRequireDefault(require("../../images/close-icon.svg"));
var _rightCaretLightGray = _interopRequireDefault(require("../../images/right-caret-light-gray.svg"));
var _useMouse = _interopRequireDefault(require("../../utils/hooks/useMouse"));
var _NavBar = require("../NavBar/NavBar");
var _Button = _interopRequireDefault(require("../Button/Button"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const LanguageSelector = _ref => {
  let {
    labels,
    settings,
    languages,
    regions,
    saveLanguage,
    handleLanguageSelectorDeployed = () => {},
    languageSelectorDeployed
  } = _ref;
  const {
    setDesktopSearchDeployed,
    handleSectorFlyoutDeployed,
    closeAllDropDowns
  } = (0, _react.useContext)(_NavBar.NavBarContext);
  const [currentSettings, setCurrentSettings] = (0, _react.useState)(settings);
  const [currentLanguage, setCurrentLanguage] = (0, _react.useState)(settings?.language);
  const [currentRegion, setCurrentRegion] = (0, _react.useState)(settings?.region);
  const [sectionDeployed, setSectionDeployed] = (0, _react.useState)("region");
  let checkComponent = false;
  const selfTriggeredSwitch = (0, _react.useRef)(false);
  const {
    mouse
  } = (0, _useMouse.default)();
  (0, _react.useEffect)(() => {
    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("click", checkLanguageSelector);
      }
    };
  }, []);
  (0, _react.useEffect)(() => {
    if (typeof window !== "undefined") {
      setCurrentSettings(settings);
      if (!currentLanguage && settings?.language) {
        setCurrentLanguage(settings?.language);
      }
      if (!currentRegion && settings?.region && regions?.length) {
        setCurrentRegion(settings?.region);
      }
    }
    if (!regions?.length) {
      setSectionDeployed("language");
    }
  }, [settings]);
  const handleSaveLanguage = () => {
    const newSettings = {
      region: currentRegion,
      language: currentLanguage
    };
    setCurrentSettings(newSettings);
    saveLanguage(newSettings);
    handleLanguageSelectorDeployed();
    selfTriggeredSwitch.current = true;
    if (typeof window !== "undefined") {
      window?.stackbit?.setLocale(currentLanguage?.code);
    }
  };
  const checkLanguageSelector = () => {
    if (checkComponent) {
      handleLanguageSelectorDeployed(false);
      checkComponent = false;
    }
  };
  const bodyMouseLeave = () => {
    checkComponent = true;
    if (typeof document !== "undefined") {
      window.addEventListener("click", checkLanguageSelector);
    }
  };
  const handleClick = () => {
    closeAllDropDowns();
    handleSectorFlyoutDeployed ? handleSectorFlyoutDeployed(false) : null;
    setDesktopSearchDeployed ? setDesktopSearchDeployed(false) : null;
    handleLanguageSelectorDeployed();
    checkComponent = true;
  };
  const handleClickWithEnter = (e, fn) => {
    if (e.keyCode === 13) {
      fn();
      checkComponent = true;
    }
  };
  const setStateWithEnter = (e, state, item) => {
    if (e.keyCode === 13) {
      state(item);
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "luna-language-selector"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: mouse ? `luna-language-selector__header ${languageSelectorDeployed && "luna-language-selector__header-deployed"}` : `luna-language-selector__header tabFocus ${languageSelectorDeployed && "luna-language-selector__header-deployed"}`,
    tabIndex: "0",
    onClick: () => handleClick(),
    onKeyDown: e => handleClickWithEnter(e, handleClick),
    "aria-label": `${currentSettings?.region}: Change Region or language`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "luna-language-selector__header-icon"
  }, languageSelectorDeployed ? /*#__PURE__*/_react.default.createElement("img", {
    src: _closeIcon.default,
    alt: "close icon",
    className: "luna-language-selector__header-icon-close"
  }) : /*#__PURE__*/_react.default.createElement("img", {
    src: _iconGlobe.default,
    alt: "globe icon",
    className: "luna-language-selector__header-icon-globe"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "luna-language-selector__header-mobile-icon"
  }, languageSelectorDeployed && /*#__PURE__*/_react.default.createElement("img", {
    className: "luna-language-selector__header-mobile-icon-caret",
    src: _rightCaretLightGray.default,
    alt: "caret icon"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: `luna-language-selector__header-text ${languageSelectorDeployed && "luna-language-selector__header-text-deployed"}`
  }, regions?.length > 1 && currentSettings?.region && currentSettings?.region?.toLowerCase() !== "international" && /*#__PURE__*/_react.default.createElement("div", {
    className: "luna-language-selector__header-text-region"
  }, currentSettings?.region, /*#__PURE__*/_react.default.createElement("span", {
    className: "luna-language-selector__header-text-divider"
  }, "|")), currentSettings?.language && /*#__PURE__*/_react.default.createElement("div", {
    className: "luna-language-selector__header-text-language"
  }, currentSettings?.language?.nativeField))), languageSelectorDeployed && /*#__PURE__*/_react.default.createElement("div", {
    className: mouse && regions?.length ? "luna-language-selector__body" : !mouse && regions?.length ? "luna-language-selector__body tabFocus" : !regions?.length ? "luna-language-selector__body no-regions" : "luna-language-selector__body",
    tabIndex: "0",
    onMouseLeave: () => bodyMouseLeave()
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "luna-language-selector__body-content"
  }, regions && regions?.length && /*#__PURE__*/_react.default.createElement("div", {
    className: `luna-language-selector__body-section ${sectionDeployed === "region" ? "luna-language-selector__body-section--region-selected" : ""}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `luna-language-selector__body-section-title ${sectionDeployed === "region" ? "luna-language-selector__body-section-title--selected" : "luna-language-selector__body-section-title--no-selected"}`,
    onClick: () => setSectionDeployed("region")
  }, labels?.region || "REGION"), /*#__PURE__*/_react.default.createElement("div", {
    className: `luna-language-selector__body-section-items ${sectionDeployed === "region" ? "luna-language-selector__body-section-items--expanded" : "luna-language-selector__body-section-items--no-expanded"}`
  }, regions && regions?.length > 0 && regions?.map((region, index) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: `region-${index}`,
      className: mouse ? "luna-language-selector__body-section-item" : "luna-language-selector__body-section-item tabFocus",
      onClick: () => setCurrentRegion(region),
      onKeyDown: e => setStateWithEnter(e, setCurrentRegion, region),
      "aria-label": `${region}`,
      tabIndex: "0"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "luna-language-selector__body-section-item-icon"
    }, region === currentRegion && /*#__PURE__*/_react.default.createElement("img", {
      // id={`region-selected-icon-${index}`}
      src: _checkBlue.default,
      alt: "item selected"
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "luna-language-selector__body-section-item-text"
    }, region));
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: `luna-language-selector__body-section ${sectionDeployed === "language" && regions?.length ? "luna-language-selector__body-section--lang-selected" : sectionDeployed === "language" && !regions?.length ? "luna-language-selector__body-section--lang-selected no-regions" : ""}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `luna-language-selector__body-section-title ${sectionDeployed === "language" ? "luna-language-selector__body-section-title--selected" : "luna-language-selector__body-section-title--no-selected"}`,
    onClick: () => setSectionDeployed("language")
  }, labels?.language || "LANGUAGE"), /*#__PURE__*/_react.default.createElement("div", {
    className: `luna-language-selector__body-section-items ${sectionDeployed === "language" ? "luna-language-selector__body-section-items--expanded" : "luna-language-selector__body-section-items--no-expanded"}`
  }, languages && languages?.length > 0 && languages?.map((language, index) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: `region-${index}`,
      className: mouse ? "luna-language-selector__body-section-item" : "luna-language-selector__body-section-item tabFocus",
      onClick: () => setCurrentLanguage(language),
      onKeyDown: e => setStateWithEnter(e, setCurrentLanguage, language),
      "aria-label": `${language?.nativeField} (${language?.translatableName})`,
      tabIndex: "0"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "luna-language-selector__body-section-item-icon"
    }, language?.code === currentLanguage?.code && /*#__PURE__*/_react.default.createElement("img", {
      // id={`language-selected-icon-${index}`}
      src: _checkBlue.default,
      alt: "item selected"
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "luna-language-selector__body-section-item-text"
    }, language?.nativeField, " ", language?.translatableName && `(${language?.translatableName})`));
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "luna-language-selector__body-fade"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "luna-language-selector__body-footer"
  }, /*#__PURE__*/_react.default.createElement("div", {
    onClick: () => handleLanguageSelectorDeployed(false),
    onKeyDown: e => handleClickWithEnter(e, handleLanguageSelectorDeployed),
    className: mouse ? "luna-language-selector__body-footer-link" : "luna-language-selector__body-footer-link tabFocus",
    tabIndex: "0"
  }, labels?.buttons?.cancel || "Cancel"), /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: () => handleSaveLanguage(),
    onKeyDown: e => handleClickWithEnter(e, handleSaveLanguage),
    className: "ter-button--primary--1 luna-language-selector__body-footer-button",
    size: "md",
    text: labels?.buttons?.ok || "OK"
  }))));
};
var _default = LanguageSelector;
exports.default = _default;